import { CareersForm } from '@/components/public/CareersForm';
import { Reveal } from '@/components/public/Reveal';
import { Seo } from '@/components/public/Seo';
import { Eyebrow, Lede, Section } from '@/components/public/Section';
import { CAREERS } from '@/lib/public-content';

/*
 * `/careers` — ROADMAP.md §8.5 for the page, §8.7 for the form.
 *
 * **This is the one surface receiving real traffic today**, and §8.7 is
 * emphatic: "the form is the one thing that must not regress."
 *
 * The hero is **centred** — like Contact's, it has no photograph beside it, and
 * left-flush left a dead margin at desktop width. The form below it is left,
 * because a form is read and filled top to bottom and centred labels are worse
 * to scan.
 */

export function CareersPage() {
  return (
    <>
      <Seo title={CAREERS.title} description={CAREERS.description} path="/careers" />

      <section aria-labelledby="careers-heading" className="relative overflow-hidden bg-ink-50">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-gradient-to-b from-honey-100/70 to-ink-50"
        />

        <div className="relative mx-auto max-w-3xl px-4 py-16 text-center sm:px-6 sm:py-24">
          <Reveal>
            <Eyebrow>{CAREERS.eyebrow}</Eyebrow>
            <h1
              id="careers-heading"
              className="mt-3 text-balance text-[38px] font-bold leading-[1.08] tracking-tight sm:text-[48px]"
            >
              {CAREERS.heading}
            </h1>
            <Lede className="mx-auto">{CAREERS.body}</Lede>
          </Reveal>
        </div>
      </section>

      <Section>
        {/* Centred column rather than left-flush — the form is the only thing on
            this page, so pinning it to one side left two thirds of the width
            empty. */}
        <Reveal className="mx-auto max-w-3xl">
          <CareersForm />
        </Reveal>
      </Section>
    </>
  );
}
